import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { useCountdown } from './hooks';
import { CHECKOUT_URLS } from './checkoutUrls';
export function UrgencyCountdown() {
  const timeLeft = useCountdown(86007); // 23:53:27
  return <section className="py-16 px-4 bg-coral text-center" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-6" data-id="element-135">
          ⏰ EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h2>
        <div className="text-3xl md:text-5xl font-black text-white mb-6 tracking-tighter tabular-nums drop-shadow-lg" data-id="element-136">
          {timeLeft}
        </div>
        <p className="text-xl text-white font-medium mb-8" data-id="element-137">
          Después sube $10.000 ARS y no vuelve a bajar.
        </p>

        <div className="mb-10 max-w-md mx-auto" data-id="element-138">
          <div className="text-white font-bold mb-2 text-left" data-id="element-139">
            Cupos al precio de lanzamiento: 70% tomados
          </div>
          <div className="h-4 w-full bg-white/30 rounded-full overflow-hidden" data-id="element-140">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '70%'
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="h-full bg-gold rounded-full" data-id="element-141" />
          </div>
        </div>

        <a href="#pricing" className="inline-block bg-purple-deep hover:bg-purple-dark text-gold font-extrabold text-xl py-5 px-10 rounded-full shadow-2xl transform transition hover:scale-105" data-id="element-142">
          → ASEGURAR MI PRECIO AHORA
        </a>
      </div>
    </section>;
}
export function Pricing() {
  const [selected, setSelected] = useState<'primaria' | 'megapack' | 'secundaria'>('megapack');
  const plans = {
    primaria: {
      icon: '📘',
      title: 'PRIMARIA',
      desc: '6 tomos + 90 actividades + 6 bonus',
      oldPrice: '$49.990',
      price: '$16.990',
      ctaText: '→ QUIERO PRIMARIA',
      url: CHECKOUT_URLS.primaria
    },
    megapack: {
      icon: '🏆',
      title: 'PACK COMPLETO',
      desc: 'Primaria + Secundaria + 180 Actividades + Bonus + 2 Ebooks Elite',
      oldPrice: '$99.980',
      price: '$27.990',
      ctaText: '🏆 SÍ, QUIERO EL PACK COMPLETO →',
      url: CHECKOUT_URLS.megapack
    },
    secundaria: {
      icon: '📗',
      title: 'SECUNDARIA',
      desc: '6 tomos + 90 actividades + 6 bonus',
      oldPrice: '$49.990',
      price: '$18.990',
      ctaText: '→ QUIERO SECUNDARIA',
      url: CHECKOUT_URLS.secundaria
    }
  };
  const order: Array<'primaria' | 'megapack' | 'secundaria'> = ['primaria', 'megapack', 'secundaria'];
  const current = plans[selected];
  return <section id="pricing" className="py-20 px-4 bg-cream" data-id="element-143">
      <div className="max-w-3xl mx-auto" data-id="element-144">
        <div className="text-center mb-12" data-id="element-145">
          <h2 className="text-4xl md:text-5xl font-bold text-purple-deep mb-4" data-id="element-146">
            Elegí tu Arte 360:
          </h2>
          <p className="text-lg md:text-xl text-purple" data-id="element-147">
            Todas las opciones incluyen los 6 bonus estratégicos
          </p>
        </div>

        <div className="space-y-4 mb-8" data-id="element-148">
          {order.map(key => {
          const plan = plans[key];
          const isSelected = selected === key;
          const isMegapack = key === 'megapack';
          return <button key={key} onClick={() => setSelected(key)} className={`w-full text-left rounded-2xl border-2 p-5 md:p-6 transition-all relative ${isSelected ? isMegapack ? 'bg-cream-dark border-coral shadow-xl' : 'bg-white border-coral shadow-xl' : 'bg-white border-gray-200 hover:border-purple/30'}`} data-id="element-149">
                <div className="flex items-center gap-4" data-id="element-150">
                  {/* Radio */}
                  <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-coral' : 'border-gray-300'}`} data-id="element-151">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-coral" data-id="element-152" />}
                  </div>

                  {/* Title + desc */}
                  <div className="flex-grow min-w-0" data-id="element-153">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-154">
                      <h3 className="text-lg md:text-2xl font-extrabold text-purple-deep flex items-center gap-2" data-id="element-155">
                        <span data-id="element-156">{plan.icon}</span> {plan.title}
                      </h3>
                      {isMegapack && <>
                          <span className="bg-gold text-purple-deep text-[10px] md:text-xs font-bold px-2 py-1 rounded-full flex items-center gap-1 whitespace-nowrap" data-id="element-157">
                            ⭐ MÁS ELEGIDO
                          </span>
                          <span className="bg-coral/10 text-coral text-[10px] md:text-xs font-bold px-2 py-1 rounded-full whitespace-nowrap" data-id="element-158">
                            AHORRÁS $7.990
                          </span>
                        </>}
                    </div>
                    <p className="text-sm md:text-base text-purple" data-id="element-159">
                      {plan.desc}
                    </p>
                  </div>

                  {/* Prices */}
                  <div className="text-right flex-shrink-0" data-id="element-160">
                    <div className="text-xs md:text-sm text-gray-400 line-through" data-id="element-161">
                      {plan.oldPrice}
                    </div>
                    <div className={`text-xl md:text-3xl font-extrabold ${isMegapack && isSelected ? 'text-coral' : 'text-purple-deep'}`} data-id="element-162">
                      {plan.price}
                    </div>
                  </div>
                </div>
              </button>;
        })}
        </div>

        {/* Main CTA — dynamic based on selection */}
        <a href={current.url} target="_blank" rel="noopener noreferrer" className="block w-full bg-coral hover:bg-coral-dark text-white font-extrabold text-lg md:text-2xl py-5 md:py-6 px-6 rounded-2xl text-center shadow-xl transform transition hover:scale-[1.02] tracking-wide" data-id="element-163">
          {current.ctaText}
        </a>

        <p className="text-center italic text-purple mt-5 mb-8 text-sm md:text-base" data-id="element-164">
          {selected === 'megapack' ? 'La opción más elegida por docentes que enseñan en los dos niveles' : selected === 'primaria' ? 'Ideal si solo das clases en nivel primario' : 'Ideal si solo das clases en nivel secundario'}
        </p>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm md:text-base text-purple font-semibold border-t border-purple/10 pt-6" data-id="element-165">
          <span className="flex items-center gap-1" data-id="element-166">🔒 Pago seguro</span>
          <span className="flex items-center gap-1" data-id="element-167">⚡ Acceso en 5 min</span>
          <span className="flex items-center gap-1" data-id="element-168">🛡️ Garantía 7 días</span>
          <span className="flex items-center gap-1" data-id="element-169">💳 Mercado Pago</span>
        </div>
      </div>
    </section>;
}
export function MegapackDetail() {
  const items = ['12 tomos completos (Primaria + Secundaria)', '180 actividades con secuencia pedagógica', 'Ejercicios graficados en cada actividad', '6 Bonus estratégicos de gestión docente', 'Ebook Elite 1: 50 Clases Cero Presupuesto', 'Ebook Elite 2: Tecnología Low-Cost sin WiFi', 'Acceso inmediato PDF', 'Listo para fotocopiadora'];
  return <section className="py-20 px-4 bg-purple-deep text-center" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <h2 className="text-2xl md:text-3xl font-bold text-gold mb-4 leading-snug" data-id="element-172">
          LA OPCIÓN MÁS ELEGIDA POR DOCENTES
          <br data-id="element-173" />
          QUE ENSEÑAN EN LOS DOS NIVELES
        </h2>
        <h3 className="text-xl text-cream font-bold mb-10" data-id="element-174">
          EL PACK COMPLETO INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left max-w-2xl mx-auto mb-12" data-id="element-175">
          {items.map((item, i) => <div key={i} className="flex items-center gap-3 text-white" data-id="element-176">
              <span className="text-gold" data-id="element-177">✅</span>
              <span className="font-medium" data-id="element-178">{item}</span>
            </div>)}
        </div>

        <div className="text-5xl md:text-6xl font-extrabold text-gold mb-10" data-id="element-179">
          Solo por $27.990 ARS
        </div>

        <a href={CHECKOUT_URLS.megapack} target="_blank" rel="noopener noreferrer" className="inline-block bg-gold hover:bg-gold-dark text-black font-extrabold text-xl py-5 px-10 rounded-full shadow-lg transform transition hover:scale-105" data-id="element-180">
          🏆 QUIERO MI PACK COMPLETO AHORA
        </a>
      </div>
    </section>;
}
const testimonialColors = ['coral', 'teal', 'gold', 'pink-hot', 'purple', 'coral'];
export function TestimonialsExtended() {
  const testimonials = [{
    initials: 'MG',
    quote: 'Compré el pack un domingo a la noche. El lunes tenía todo organizado por grado. Las actividades están pensadas para que los chicos realmente produzcan, no solo para llenar el tiempo de clase.',
    location: 'Córdoba | Docente de Arte Primaria'
  }, {
    initials: 'CR',
    quote: 'Empecé con Primaria y a los 3 días compré el Megapack. Doy clases en los dos niveles y no podía trabajar con la mitad. Los bonus de gestión me cambiaron la vida.',
    location: 'Mendoza | Docente Primaria y Secundaria'
  }, {
    initials: 'RM',
    quote: 'Lo que más valoro es que está organizado POR GRADO Y AÑO. No tengo que adivinar qué le corresponde a cada curso. Todo está pensado y secuenciado.',
    location: 'Buenos Aires | Docente de Arte'
  }, {
    initials: 'FL',
    quote: 'Tenía miedo de que fuera material genérico. Pero desde la primera clase noté que está pensado para Argentina, para el aula real, para docentes que tienen 35 chicos y poco tiempo.',
    location: 'Tucumán | Docente de Arte Primaria'
  }, {
    initials: 'LP',
    quote: 'El módulo de Tecnología Low-Cost me salvó. La directora me pidió integración de TICs y yo no tenía ni WiFi. Ahora doy animación con papel y lápiz y suena increíble en las planificaciones.',
    location: 'Rosario | Docente de Arte Secundaria'
  }, {
    initials: 'VT',
    quote: 'Entregué la Planificación Anual el primer día de clases. Mi directora me preguntó cómo la tenía tan completa. No le dije que tardé 5 minutos en personalizarla.',
    location: 'Santa Fe | Docente de Arte Primaria'
  }];
  const colorClass = (c: string) => {
    if (c === 'coral') return {
      bg: 'bg-coral',
      border: 'border-coral'
    };
    if (c === 'teal') return {
      bg: 'bg-teal',
      border: 'border-teal'
    };
    if (c === 'gold') return {
      bg: 'bg-gold',
      border: 'border-gold'
    };
    if (c === 'pink-hot') return {
      bg: 'bg-pink-hot',
      border: 'border-pink-hot'
    };
    return {
      bg: 'bg-purple',
      border: 'border-purple'
    };
  };
  return <section className="py-20 px-4 bg-cream" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <div className="text-center mb-16" data-id="element-183">
          <h2 className="text-3xl md:text-4xl font-bold text-purple-deep mb-4" data-id="element-184">
            Lo que dicen los docentes que ya tienen su Arte 360:
          </h2>
          <p className="text-xl font-bold text-coral" data-id="element-185">
            +500 docentes de Argentina ya lo usan
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-186">
          {testimonials.map((t, i) => {
          const c = colorClass(testimonialColors[i]);
          return <div key={i} className={`bg-white p-8 rounded-xl shadow-md border-t-4 ${c.border} hover:shadow-xl hover:-translate-y-1 transition transform`} data-id="element-187">
                <div className={`w-12 h-12 ${c.bg} text-white rounded-full flex items-center justify-center font-bold text-lg mb-4`} data-id="element-188">
                  {t.initials}
                </div>
                <div className="text-gold text-lg mb-3 tracking-wider" aria-label="5 de 5 estrellas" data-id="element-189">
                  ★★★★★
                </div>
                <p className="text-gray-700 mb-6 italic leading-relaxed" data-id="element-190">
                  "{t.quote}"
                </p>
                <p className="text-sm font-bold text-purple flex items-center gap-1" data-id="element-191">
                  📍 {t.location}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream-dark text-center" data-id="element-192">
      <div className="max-w-3xl mx-auto" data-id="element-193">
        <div className="text-6xl mb-6" data-id="element-194">🛡️</div>
        <h2 className="text-3xl md:text-4xl font-bold text-purple-deep mb-10" data-id="element-195">
          GARANTÍA ARTE 360 — 7 DÍAS
        </h2>

        <div className="flex flex-col md:flex-row justify-center gap-8 mb-12 text-lg font-medium text-purple-dark" data-id="element-196">
          <div className="flex items-center gap-2" data-id="element-197">
            <span className="text-coral font-bold text-2xl" data-id="element-198">1.</span> Abrís los
            12 tomos.
          </div>
          <div className="flex items-center gap-2" data-id="element-199">
            <span className="text-teal font-bold text-2xl" data-id="element-200">2.</span> Revisás los
            6 bonus.
          </div>
          <div className="flex items-center gap-2" data-id="element-201">
            <span className="text-pink-hot font-bold text-2xl" data-id="element-202">3.</span> Los
            usás en el aula si querés.
          </div>
        </div>

        <div className="bg-white p-8 rounded-2xl shadow-xl border-t-4 border-teal mb-10" data-id="element-203">
          <h3 className="text-2xl font-bold text-purple-deep mb-6" data-id="element-204">
            Si en 7 días no es lo que esperabas:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left max-w-lg mx-auto" data-id="element-205">
            <div className="flex items-center gap-2 text-purple-dark" data-id="element-206">
              <span className="text-teal" data-id="element-207">✅</span> Te devolvemos el 100%.
            </div>
            <div className="flex items-center gap-2 text-purple-dark" data-id="element-208">
              <span className="text-teal" data-id="element-209">✅</span> Sin preguntas.
            </div>
            <div className="flex items-center gap-2 text-purple-dark" data-id="element-210">
              <span className="text-teal" data-id="element-211">✅</span> Sin formularios.
            </div>
            <div className="flex items-center gap-2 text-purple-dark" data-id="element-212">
              <span className="text-teal" data-id="element-213">✅</span> Sin drama.
            </div>
          </div>
        </div>

        <p className="text-purple max-w-xl mx-auto leading-relaxed" data-id="element-214">
          La confianza que tenemos en Arte 360 nos permite ofrecerte eso. Más de
          500 docentes ya lo saben.
        </p>
      </div>
    </section>;
}
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo Arte 360 después de comprar?',
    a: 'Al instante. Apenas confirmado el pago por Mercado Pago, recibís un email con el link de descarga. En menos de 5 minutos tenés todo el material en tu celular o computadora.'
  }, {
    q: '¿Sirve para mi provincia?',
    a: 'Sí. El material está diseñado para adaptarse a los diseños curriculares de todas las provincias argentinas. Los contenidos son transversales a cualquier jurisdicción.'
  }, {
    q: '¿Está en blanco y negro?',
    a: 'Sí. Todo el material está optimizado para fotocopiadora en blanco y negro. No necesitás impresora a color ni gastar en tinta costosa.'
  }, {
    q: '¿Los 6 bonus están en todas las ofertas?',
    a: 'Sí. Los 6 bonus estratégicos están incluidos en el Pack Primaria, el Pack Secundaria y el Pack Completo. En todas las opciones sin excepción.'
  }, {
    q: '¿Puedo comprar Primaria ahora y Secundaria después?',
    a: 'Sí, podés hacerlo. Pero si trabajás en los dos niveles, el Pack Completo es mucho más conveniente: te lllevas todo por $27.990 en lugar de pagar $16.990 + $18.990 por separado.'
  }, {
    q: '¿Los Ebooks Élite están en todas las ofertas?',
    a: 'No. Los 2 Ebooks Élite son exclusivos del Pack Completo. No se venden por separado.'
  }, {
    q: '¿Funciona si no tengo WiFi en la escuela?',
    a: 'Perfecto para eso. El material es 100% descargable. Una vez que lo tenés, no necesitás internet para usarlo. Además, el Ebook Elite 2 está diseñado específicamente para enseñar tecnología sin depender de la conexión.'
  }, {
    q: '¿Sirve para cualquier escuela?',
    a: 'Sí. Está diseñado para contextos de bajos recursos, sin materiales y con grupos numerosos. La Argentina real, no la de los catálogos importados.'
  }, {
    q: '¿Tiene garantía real?',
    a: '7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero sin preguntas, sin formularios y sin drama.'
  }, {
    q: '¿Qué diferencia tiene con otros materiales que vi?',
    a: 'La mayoría de los materiales de Arte están pensados para escuelas con presupuesto, WiFi y grupos de 15 alumnos. Arte 360 está pensado para la escuela argentina real: sin plata, sin conexión y con 35 chicos. Esa es la diferencia.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqColors = ['border-coral', 'border-teal', 'border-purple', 'border-gold', 'border-pink-hot', 'border-coral', 'border-teal', 'border-purple', 'border-gold', 'border-pink-hot'];
  const faqText = ['text-coral', 'text-teal', 'text-purple', 'text-gold-dark', 'text-pink-hot', 'text-coral', 'text-teal', 'text-purple', 'text-gold-dark', 'text-pink-hot'];
  return <section className="py-20 px-4 bg-cream" data-id="element-215">
      <div className="max-w-3xl mx-auto" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-purple-deep mb-12" data-id="element-217">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-4" data-id="element-218">
          {faqs.map((faq, i) => <div key={i} className="rounded-lg overflow-hidden shadow-md bg-white" data-id="element-219">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className={`w-full text-left p-6 bg-white hover:bg-cream flex justify-between items-center transition border-l-4 ${faqColors[i]}`} data-id="element-220">
                <span className="font-bold text-purple-deep pr-4" data-id="element-221">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === i ? 180 : 0
            }} data-id="element-222">
                  <ChevronDown className={faqText[i]} data-id="element-223" />
                </motion.div>
              </button>
              <AnimatePresence data-id="element-224">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} className="overflow-hidden bg-cream-dark" data-id="element-225">
                    <div className={`p-6 pt-6 text-purple-dark leading-relaxed border-l-4 ${faqColors[i]}`} data-id="element-226">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}
export function FinalCTA() {
  const timeLeft = useCountdown(86007);
  return <section className="py-20 px-4 bg-purple-deep text-center" data-id="element-227">
      <div className="max-w-5xl mx-auto" data-id="element-228">
        <div className="text-gold font-bold text-xl mb-8 tracking-widest" data-id="element-229">
          🎨 ARTE 360
        </div>
        <p className="text-2xl md:text-3xl text-cream italic font-light mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-230">
          "El próximo domingo podés seguir buscando ideas en Pinterest que no
          funcionan en tu aula.
          <br data-id="element-231" />
          <br data-id="element-232" />O podés tener todo resuelto desde hoy."
        </p>

        <div className="text-5xl md:text-6xl font-black text-gold mb-12 tabular-nums" data-id="element-233">
          {timeLeft}
        </div>

        <div className="flex flex-col md:flex-row justify-center items-center gap-6 mb-12" data-id="element-234">
          <a href={CHECKOUT_URLS.primaria} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-coral hover:bg-coral-dark text-white font-bold py-4 px-8 rounded-xl transition flex flex-col items-center shadow-lg" data-id="element-235">
            <span className="text-sm text-white/80 mb-1" data-id="element-236">📘 PRIMARIA</span>
            <span className="text-xl mb-1" data-id="element-237">$16.990 ARS</span>
            <span className="text-sm" data-id="element-238">→ QUIERO PRIMARIA</span>
          </a>

          <a href={CHECKOUT_URLS.megapack} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-gold hover:bg-gold-dark text-purple-deep font-extrabold py-6 px-10 rounded-xl transition transform hover:scale-105 shadow-2xl flex flex-col items-center border-2 border-gold" data-id="element-239">
            <span className="text-sm font-bold mb-1" data-id="element-240">🏆 PACK COMPLETO ⭐</span>
            <span className="text-3xl mb-1" data-id="element-241">$27.990 ARS</span>
            <span className="text-sm" data-id="element-242">→ QUIERO MI PACK COMPLETO</span>
          </a>

          <a href={CHECKOUT_URLS.secundaria} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-teal hover:bg-teal-dark text-white font-bold py-4 px-8 rounded-xl transition flex flex-col items-center shadow-lg" data-id="element-243">
            <span className="text-sm text-white/80 mb-1" data-id="element-244">📗 SECUNDARIA</span>
            <span className="text-xl mb-1" data-id="element-245">$18.990 ARS</span>
            <span className="text-sm" data-id="element-246">→ QUIERO SECUNDARIA</span>
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-cream font-medium" data-id="element-247">
          <span className="flex items-center gap-1" data-id="element-248">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-1" data-id="element-249">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-250">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-251">
            💳 Mercado Pago | Tarjeta de crédito
          </span>
        </div>
      </div>
    </section>;
}
export function Footer() {
  return <footer className="py-12 px-4 bg-purple-deep border-t-4 border-gold text-center" data-id="element-252">
      <div className="max-w-4xl mx-auto" data-id="element-253">
        <div className="text-gold font-bold text-lg mb-6 tracking-widest" data-id="element-254">
          🎨 ARTE 360
        </div>
        <p className="text-cream/70 text-sm mb-8 max-w-md mx-auto leading-relaxed" data-id="element-255">
          El sistema de planificación N°1 para docentes de Arte de primaria y
          secundaria en Argentina.
          <br data-id="element-256" />
          <br data-id="element-257" />
          Porque enseñar Arte no debería costarte todos los domingos del año.
        </p>
        <div className="text-cream/40 text-xs" data-id="element-258">
          © ARTE 360
          <br data-id="element-259" />
          Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}